import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { StorageService } from "./storage.service";
import { StorageKeys } from "./storage-keys";

@Injectable({
    providedIn: 'root'
})
export class LogService {

    api = environment.tenantApi + "tenant";


    constructor(
        private httpClient: HttpClient,
        private storageService: StorageService
    ) {
    }


    /**
     * Save Logs
     * @param payload 
     * @returns 
     */
    saveLogs(payload: any): Observable<any> {
        return from(this.storageService.getItem<string>(StorageKeys.TENANT_NAME)).pipe(
            switchMap(tenantId => {
                payload.tenantId = tenantId;
        return this.httpClient.post(`${this.api}/logs`, payload);
            })
        );
    }
}
